<div class="row mt-3 d-flex justify-content-between">
  <div class="col-md-5 d-flex align-items-center">
    @for (tab of tabs; track tab) {
      <div class="select-item" [class.active]="selectedTab == tab.id" (click)="selectTab(tab.id)">
        {{ tab.value | translate }}
      </div>
    }
  </div>
  <div class="col-md-5 d-flex justify-content-end align-items-center">
    <div class="search-panel">
      <input
        class="form-control search-input"
        [(ngModel)]="params.filterString"
        [placeholder]="
          ('common.search' | translate) + ' ' + ('mysec.filter' + params.filterBy | translate)
        "
        (keydown.enter)="getList(true)"
        name="search"
        required
      />
      <div class="pitchin-icon pitchin-icon-search"></div>
    </div>
    <div class="filter-btn dropdown" ngbDropdown placement="bottom-right">
      <div class="d-flex align-items-center w-max" ngbDropdownToggle>
        <div class="d-none d-lg-block mr-3">{{ 'mysec.filter' + params.filterBy | translate }}</div>
        <div class="pitchin-icon pitchin-icon-arrow-down-black"></div>
      </div>
      <div class="dropdown-menu p-1 filter-dropdown-menu" ngbDropdownMenu>
        @for (filter of filters; track filter) {
          <button ngbDropdownItem (click)="filterList(filter)">
            {{ 'mysec.filter' + filter | translate }}
          </button>
        }
      </div>
    </div>
  </div>
</div>
@if (!isLoading) {
  <div class="row mt-3">
    @if (openOrderList) {
      <div class="col-12">
        <div class="mattable-container mysec-table">
          <mat-table class="responsive-table" [dataSource]="openOrderList">
            <ng-container matColumnDef="Company">
              <mat-header-cell *matHeaderCellDef>{{
                'company.company' | translate
              }}</mat-header-cell>
              <mat-cell *matCellDef="let item">
                <div class="pointer" [routerLink]="['/pstx', item.share?.tickerCode]">
                  <div class="text-black font-weight-bold">{{ item.share?.name }}</div>
                  <div class="font-size-small">{{ item.share?.registrationNumber }}</div>
                </div>
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="TickerCode">
              <mat-header-cell *matHeaderCellDef
                >{{ 'mysec.tickerCode' | translate }}
              </mat-header-cell>
              <mat-cell *matCellDef="let item">
                {{ item.share?.tickerCode }}
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="Type">
              <mat-header-cell *matHeaderCellDef>{{ 'mysec.type' | translate }} </mat-header-cell>
              <mat-cell *matCellDef="let item">
                <div
                  class="font-weight-bold font-size-small text-uppercase trading-type"
                  [ngClass]="TradingType[item.order?.action]"
                >
                  {{ 'mysec.' + TradingType[item.order?.action] | translate }}
                </div>
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="Price">
              <mat-header-cell *matHeaderCellDef
                >{{ 'Price per share' | translate }}
              </mat-header-cell>
              <mat-cell *matCellDef="let item">
                {{
                  item.order?.price
                    ? (item.order?.price | numberSuffix: { numberFormat: '1.2-2' })
                    : '-'
                }}
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="ShareQuantity">
              <mat-header-cell *matHeaderCellDef
                >{{ 'mysec.shareQty' | translate }}
              </mat-header-cell>
              <mat-cell *matCellDef="let item">
                {{ item.order?.orderQuantity | number }}
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="OrderMatched">
              <mat-header-cell *matHeaderCellDef
                >{{ 'mysec.orderMatch' | translate }}
              </mat-header-cell>
              <mat-cell *matCellDef="let item">
                {{ item.order?.matchedQuantity ? (item.order?.matchedQuantity | number) : '-' }}
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="OrderId">
              <mat-header-cell *matHeaderCellDef
                >{{ 'mysec.orderNo' | translate }}
              </mat-header-cell>
              <mat-cell *matCellDef="let item">
                {{ item.order?.orderNo }}
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="Time">
              <mat-header-cell *matHeaderCellDef>{{ 'common.time' | translate }} </mat-header-cell>
              <mat-cell *matCellDef="let item">
                {{ item.order?.createdAt | amDateFormat: 'DD MMM yyyy, hh:mm a' }}
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="Status">
              <mat-header-cell *matHeaderCellDef
                >{{ 'common.status' | translate }}
              </mat-header-cell>
              <mat-cell *matCellDef="let item">
                <div
                  class="d-flex align-items-baseline"
                  [ngClass]="OrderStatus[item.order?.status]"
                >
                  <i class="fa fa-circle mr-1 font-size-small"></i>
                  {{ 'mysec.' + OrderStatus[item.order?.status] | translate }}
                </div>
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="Action">
              <mat-header-cell *matHeaderCellDef [hidden]="selectedTab !== 1">{{
                'common.action' | translate
              }}</mat-header-cell>
              <mat-cell *matCellDef="let item" [hidden]="selectedTab !== 1">
                <div class="action" ngbDropdown container="body" placement="auto">
                  <div
                    class="pitchin-icon pitchin-icon-more-horizontal no-caret"
                    ngbDropdownToggle
                  ></div>
                  <div ngbDropdownMenu>
                    <div
                      class="font-weight-bold cursor-pointer"
                      ngbDropdownItem
                      (click)="selectedTab === 1 ? cancelOrder(item.order?.id) : return"
                    >
                      {{ 'mysec.cancelOrder' | translate }}
                    </div>
                  </div>
                </div>
              </mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="displayColumns"> </mat-header-row>
            <mat-row *matRowDef="let item; columns: displayColumns"> </mat-row>
          </mat-table>
        </div>
      </div>
    }
    @if (!openOrderList || openOrderList.length == 0) {
      <div class="col-12 py-4 text-center">
        {{ 'common.noRecord' | translate }}
      </div>
    }
  </div>
}
@if (isLoading) {
  <agmo-loading></agmo-loading>
}
@if (total > params.take) {
  <div class="row">
    <div class="col-lg-12">
      <div class="paging mt-3">
        <ngb-pagination
          [collectionSize]="total"
          [(pageSize)]="params.take"
          [(page)]="params.currentPage"
          (pageChange)="getList()"
          [maxSize]="5"
          [rotate]="true"
        >
          <ng-template ngbPaginationPrevious><i class="fa fa-chevron-left"></i></ng-template>
          <ng-template ngbPaginationNumber let-page>{{ page }}</ng-template>
          <ng-template ngbPaginationNext><i class="fa fa-chevron-right"></i></ng-template>
        </ngb-pagination>
      </div>
    </div>
  </div>
}
